<script lang="ts">
    export let bordered = false;
    export let hoverRows = false;
    export let stripedRows = false;
    export let condensed = false;
</script>

<template>
    <table class="table"
           class:table-bordered={bordered}
           class:table-hover={hoverRows}
           class:table-striped={stripedRows}
           class:table-condensed={condensed}>
        {#if $$slots.header}
            <thead>
                <slot name="header"></slot>
            </thead>
        {/if}
        <tbody>
            <slot name="body"></slot>
        </tbody>
        {#if $$slots.footer}
            <tfoot>
                <slot name="footer"></slot>
            </tfoot>
        {/if}
    </table>
</template>